'use client';

import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-[#020817] flex flex-col">
      {/* Minimal public header — logo only, no nav */}
      <header className="flex items-center justify-center py-6 px-6">
        <Link
          href="/landing"
          className="flex items-center gap-3 transition-opacity hover:opacity-80 focus:outline-none"
          aria-label="ChronoMind AI - Go to home"
        >
          <AppLogo
            src="/assets/images/Untitled_design-27-1772027045051.png"
            size={44}
          />
          <span className="font-heading text-xl font-bold text-white">
            ChronoMind™ AI
          </span>
        </Link>
      </header>

      {/* Page content */}
      <main className="flex-1">
        {children}
      </main>
    </div>
  );
}
